import * as React from "react";
import { QrCodeContainer } from "../../../../../../containers/modules/PaymentMethodsList/modules/QrCode/containers/QrCodeContainer.js";
const QrCode = (props) => /* @__PURE__ */ React.createElement(QrCodeContainer, { ...props });
export {
  QrCode
};
//# sourceMappingURL=QrCode.js.map
